import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../../classes/helper';
import { Listing } from '../../classes/listing';
import { DisableAgentForLsids, DisableAgentForBoards } from '../../app-config.constants';

/*
 * returns a courtesy of... message based on listing agent info
*/
@Pipe({ name: 'courtesyMessage' })
export class CourtesyMessagePipe implements PipeTransform {
  transform(listing: Listing, isEdmonton?: boolean): string {
    const agentIncorporation = listing.agentIncorporation || (listing.agent ? listing.agent.agentIncorporation : '');
    const agentName = listing.remaxAgentName || (listing.agent ? listing.agent.fullName : '');
    const officeName = listing.remaxOfficeName || (listing.agent ? listing.agent.officeName : '');

    // Scenario 4: If a listing's LSID is in DisableAgentForLsids and it is a not a Remax listing, show only Brokerage
    if ((DisableAgentForLsids.includes(listing.source) || (listing.boardName && DisableAgentForBoards.includes(listing.boardName.toLowerCase()))) && !listing.isRemaxListing) {
      return officeName;
    }
    // Scenario 3: Listing with incorporated agent
    else if (agentIncorporation) {
      if (agentName && agentIncorporation === 'Personal Real Estate Corporation') {
        if (!isEdmonton) {
          return `${agentName}, ${officeName}`;
        } else if (isEdmonton && listing.isRemaxListing) {
          return `Courtesy of ${agentName}, ${officeName}`
        } else if (isEdmonton && !listing.isRemaxListing) {
          return  `Courtesy of ${officeName}`
        }
      }
      return agentIncorporation;
    }
    // Scenario 2: Listing with associated agent
    else if (agentName) {
      if (!isEdmonton) {
        return `${agentName}, ${officeName}`;
      } else if (isEdmonton && listing.isRemaxListing) {
        return `Courtesy of ${agentName}, ${officeName}`
      } else if (isEdmonton && !listing.isRemaxListing) {
        return  `Courtesy of ${officeName}`
      }
    }
    else {
      // Scenario 1 / catchall
      return officeName;
    }
  }
}
